import { FC } from 'react';

import Modal from '../Modal/Modal';
import Button from '../Button/Button';

interface ErrorModal {
  onClear: () => void;
  error: string;
  header?: string;
}

const ErrorModal: FC<ErrorModal> = ({ header, onClear, error }) => {
  return (
    <Modal
      onCancel={onClear}
      header={header ? header : 'An Error Occurred!'}
      show={!!error}
      footer={<Button onClick={onClear}>Okay</Button>}
    >
      <p>{error}</p>
    </Modal>
  );
};

export default ErrorModal;
